import React from 'react'
import Banner from '../home/banner/banner'
import Footer from '../footer/footer'
import { Timeline, Icon } from 'antd'
import RightBtn from'../rightBtn/rightBtn';
require ( './aboutus.scss' )
import Router from 'next/router'

import {Get, wrapResponse} from './../../requst'

export default class AboutUs extends React.Component{
    static async getInitialProps(){
        const [data, profile, teams, historys, companyNews] = await Promise.all([
            wrapResponse(Get({url:'about/banner'})),
            wrapResponse(Get({url:'about/profile'})),
            wrapResponse(Get({url:'about/teams'})),
            wrapResponse(Get({url:'about/historys'})),
            wrapResponse(Get({url:'about/companyNews'})),
        ])

        const footerProps = await Footer.getInitialProps()

        return {data, profile, teams, historys, companyNews, footerProps}
    }

    constructor(props, context) {
        super(props, context)
        this.NumAutoPlusAnimation=this.NumAutoPlusAnimation.bind(this);
        this.state = {
            records:false
        }
       
    }
    componentDidMount() {
        this.Get({url:'about/records'}).then((res)=>{
            // (res.data.data)
            this.setState({records:res.data.data})
        })
    }
    teams(){
        return this.props.teams.map((item,index)=>(
            <li key={index}>
                <img src = {item.photo} alt=""/>
                <div className = "Show">
                {item.profile.substring(0, 60)}
                </div>
                <p className = "P_Con P_One">{item.name}</p>
                <p className = "P_Con">{item.position}</p>
            </li>
        ))  
    }
    historys(){
        return this.props.historys.map((item,index)=>(
            <Timeline.Item color="black" key={index}>
                <p className = "Time">{item.time}</p>
                <p className="TextHead">{item.title}</p>
                <p className = "TextCont">{item.desc}</p>
            </Timeline.Item>
        ))
    }
    companyNews(){
        return this.props.companyNews.map((item,index)=>(
            <a key={index} href={`/details/${item.id}`} >
                <div className = "ImgBox">
                    <img className = "Img" src = {item.thumb} alt=""/>
                </div>
                <p className = "P_Con P_Head">{item.title}</p>
                <p className = "P_Con P_Text">{item.desc}</p>
                <div className = "Mask_DeatilsBtm"></div>
                <div className = "Triangle"></div>
                <div className = "MaskText">
                    <p>{item.created_at.substring(0,7)}</p>
                    <p>{item.created_at.substring(8,10)}</p>
                    <img src = { require ( '../../assets/common/images/anniujiantou-bai.png' ) } alt=""/>
                </div> 
            </a>
        ))  
    }
    records(){
        return this.state.records.map((item,index)=>(
            <li key={index}>
                <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center'}}><p className = "Head" id= {'Head'+index}>0{this.NumAutoPlusAnimation('Head'+index,{time:1000,num:parseInt(item.key),regulator: 50})} </p><p style={{fontSize:'30px',margin: '25px 0 10px 0',color:' #006AEB'}}>{item.key.slice(parseInt(item.key).toString().length)}</p></div>
                <p className = "Line"></p>
                <p className = "Cont">{item.value}</p>
            </li>
        ))
    }
    //数字自增到某一值动画参数（目标元素,自定义配置）
    NumAutoPlusAnimation(targetEle, options) {  
        console.log(12, targetEle)
       
        //不传配置就把它绑定在相应html元素的data-xxxx属性上吧
        options = options || {};

        var $this = document.getElementById(targetEle),
            time = options.time || $this.innerHTML, //总时间--毫秒为单位
            finalNum = options.num || $this.innerHTML, //要显示的真实数值
            regulator = options.regulator || 100, //调速器，改变regulator的数值可以调节数字改变的速度

            step = finalNum / (time / regulator),/*每30ms增加的数值--*/
            count = 0, //计数器
            initial = 0;

        var timer = setInterval(function() {

            count = count + step;

            if(count >= finalNum) {
                clearInterval(timer);
                count = finalNum;
            }
            //t未发生改变的话就直接返回
            //避免调用text函数，提高DOM性能
            var t = Math.floor(count);
            if(t == initial) return;

            initial = t;
            
            if ($this) {
                $this.innerHTML = initial;
            }
        }, 100);
    }

    render(){
        
        return(
            <div>
                {/*<RightBtn props={this.props} callback={this.goConsulting}/>*/}
                <div style={{width:'100%',height:'630px',display:'flex',justifyContent:'center'}}>
                    <img src={this.props.data?this.props.data[0].photos:null} style={{height:'100%'}} alt=""/>
                </div>
                <div className = "About_Middle_one">
                    <div className = "ContainerBox">
                        <ul className = "NavTitle">
                            {this.state.records?this.records():null}
                        </ul>
                        <div style={{display:'flex',justifyContent:'center'}}>
                           <div style={{flex:1}}> 
                                <p className = "TextTitle" style={{textAlign:'right',width:'508px',color:'#666'}}>{this.props.profile?this.props.profile.name:null}</p>
                                {this.props.profile?<div className = "Text" dangerouslySetInnerHTML={{__html: this.props.profile.profiles}}>
                                    
                                </div>:null}
                            </div>
                            <div style={{flex:1,alignItems:'center',justifyContent:'center'}}>
                                <img style={{width:'542px',float:'right'}} src = {this.props.profile?this.props.profile.image:null} alt=""/>
                            </div>
                        
                        </div>
                    </div>
                </div>
                <div className = "About_Middle_two">
                    <div className = "ContainerBox">
                        <p className = "Title">团队介绍</p>
                        <ul className = "Content">
                            {this.props.teams?this.teams():null}
                        </ul>
                    </div>
                </div>
                <div className = "About_Middle_three">
                    <div className = "ContainerBox">
                        <p className = "Title">发展历程</p>
                        <Timeline mode="alternate">
                            {this.props.historys?this.historys():null}
                        </Timeline>
                    </div>
                </div>
                <div className = "About_Middle_four">
                    <p className = "Title">公司动态</p>
                    <p className = "SubTitle">强大功能，支撑您社交APP应用更多需求</p>
                    <ul className = "Buttom">
                        {this.props.companyNews?this.companyNews():null}
                    </ul>
                </div>
                <div className = "About_Middle_five">
                    <div className = "About_Container">
                        <p className = "Title">联系我们</p>
                        <div className = "ContentMapBox">
                            <div className = "Map"><img src={ require('../../assets/common/images/aboutditu.png') } /></div>
                            <div className = "MapText">
                                <p className = "MapTitle">泛梦科技</p>
                                <p className = "Line"></p>
                                <p className = "MapTextItem MapTextItem_Phone">联系电话：13698180606</p>
                                <p className = "MapTextItem MapTextItem_Email">邮箱：395789527@qq.com</p>
                                <p className = "MapTextItem MapTextItem_WorkTime">工作时间：9:00-18:30（工作日）</p>
                                <p className = "MapTextItem MapTextItem_site">公司地址：成都市高新区东方希望天祥广场A座2902</p>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer {...this.props.footerProps}/>
                <RightBtn props={this.props}/>
            </div>
        )
    }
}
